module.exports = __webpack_public_path__ + "static/img/content_bg_long.4e35affe.png";